import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from './common-service';
import { catchError, retry } from 'rxjs/operators';
import { ReturnStruct } from '../structs/return.struct';
import { UserLoginResponse } from './responses/admin-user/auth.response';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends CommonService {

  constructor(private router: Router,
    private httpClient: HttpClient,
    configService: AppConfigService,
   private endpointBuilder: EndpointBuilderService
) {
    super(configService);
  }

  public signIn(login: string, password: string, ip: string): Observable<any> {

    let userAuthRequest = {
      login: login,
      password: password,
      ip: ip
    };

    return this.httpClient.post<any>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAuth) + "GenerateAdminToken", userAuthRequest)
      .pipe(
        catchError(this.handleError)
      )
  }

  public signInWithGoogle(token: string, ip: string): Observable<any> {

    let userAuthRequest = {
      token: token,
      ip: ip
    };

    return this.httpClient.post<any>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAuth) + "GenerateAdminToken/email", userAuthRequest)
      .pipe(
        catchError(this.handleError)
      )
  }

  updateToken(userLoginResponse: any) {
    sessionStorage.setItem("token", JSON.stringify(userLoginResponse));
  }

  updateDefaultModule(newDefaultModule: any) {
    let data = JSON.parse(sessionStorage.getItem("token"));
    if (newDefaultModule != undefined && newDefaultModule != null) {
      data.idDefaultModule = newDefaultModule.idModule;
      data.uriDefaultModule = newDefaultModule.uri;
      data.defaultModuleName = newDefaultModule.nameModule;
    }
    else {
      data.idDefaultModule = null;
      data.uriDefaultModule = null;
      data.defaultModuleName = null;
    }
    sessionStorage.setItem("token", JSON.stringify(data));
  }

  logout() {
    sessionStorage.removeItem("token");
    this.router.navigate(['/'])
  }

  getToken() {
    let userLoginResponse: UserLoginResponse = JSON.parse(sessionStorage.getItem("token"))
    return userLoginResponse.token;
  }


  getTokenMenu() {
    let userLoginResponse: UserLoginResponse = JSON.parse(sessionStorage.getItem("token"));
    return userLoginResponse;
  }

  isAuthenticated(): boolean {
    return sessionStorage.getItem("token") == null ? false : true;
  }

  haveRolePermission(idRole: number): boolean {
    let hasRole = false;
    let userLoginResponse: UserLoginResponse = JSON.parse(sessionStorage.getItem("token"));

    userLoginResponse.listRole.forEach(element => {
      if (element.idRole == idRole) {
        hasRole = true;
      }
    });

    return hasRole;
  }
}
